import { useState } from "react";
import { TopButs } from "./TopButs"
import { FormBox } from "./FormBox"
import { MaterialTableBox } from "./MaterialTableBox"
import { ItemTableBox } from "./ItemTableBox"
import { ThreeGuarantees } from "./ThreeGuarantees"
import { OtherItem } from "./OtherItem"
import { FixedBottom } from "./FixedBottom"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceModel";

export const VrmMaintenanceDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const {
        itemDetailVisible,
        threeGuaranteesItemDetailVisible,
        detailMaterialListVisible,
        otherItemDetailListVisible,
    } = useVrmMaintenanceDetailsModel();


    return (
        <>
            <TopButs {...detailsInfo} />
            <FormBox  {...detailsInfo} />
            {itemDetailVisible && <ItemTableBox {...detailsInfo} />}
            {threeGuaranteesItemDetailVisible && <ThreeGuarantees {...detailsInfo} />}
            {detailMaterialListVisible && <MaterialTableBox {...detailsInfo} />}
            {otherItemDetailListVisible && <OtherItem {...detailsInfo} />}
            <br />
            <br />
            <br />
            <br />
            <FixedBottom {...detailsInfo} />
        </>
    )
}